module.exports = __webpack_public_path__ + "static/media/RuiAbreu-AzoSans-Regular.86503a72.woff2";